import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { LabelType } from "__generated__/enums";

const LabelTypeSelect = ({
	...rest
}: Omit<SelectProps<LabelType, false>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			{...rest}
			fetchOptions={Object.values(LabelType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			disableSearch />
	);
};

export default LabelTypeSelect;
